const SERVICE_MONITOR_PREFIX = "service-monitor.";
const DATA_DOG_LOG_LEVELS_KEY = "dataDogLogLevels";
const DISABLE_DATA_DOG_KEY = "disableDataDog";
const DATA_DOG_CLIENT_TOKEN_KEY = "dataDogClientToken";

const truthy = (value) => {
  if (typeof value === "boolean") {
    return value;
  }
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
};

function getLoggingContext() {
  return Object.keys(window.sessionStorage)
    .filter((key) => key.startsWith(SERVICE_MONITOR_PREFIX))
    .reduce((context, key) => {
      context[key] = window.sessionStorage.getItem(key);
      return context;
    }, {});
}

const resolveLogLevels = (dataDogConfig = {}) => {
  const fromStorage = sessionStorage.getItem(DATA_DOG_LOG_LEVELS_KEY);
  if (fromStorage) {
    return fromStorage
      .split(",")
      .map((level) => level.trim())
      .filter((level) => level.length > 0);
  }
  if (Array.isArray(dataDogConfig.logLevels) && dataDogConfig.logLevels.length > 0) {
    return dataDogConfig.logLevels;
  }
  return ["log", "info", "warn", "error"];
};

export function setupDataDogLogging(dataDogConfig = {}) {
  const isLocalhost = window.location.hostname.toLowerCase().startsWith("localhost");
  if (isLocalhost) {
    console.log("DataDog logging is disabled in localhost");
    return;
  }

  const disabled =
    truthy(sessionStorage.getItem(DISABLE_DATA_DOG_KEY)) || truthy(dataDogConfig.disabled);
  if (disabled) {
    console.log("DataDog logging is disabled via configuration.");
    return;
  }

  const clientToken =
    dataDogConfig.clientToken || sessionStorage.getItem(DATA_DOG_CLIENT_TOKEN_KEY);
  if (!clientToken) {
    console.warn("DataDog logging skipped: client token not provided.");
    return;
  }

  if (!window.DD_LOGS) {
    console.warn("DataDog logging library not detected on window.DD_LOGS.");
    return;
  }

  const dataDogLogLevels = resolveLogLevels(dataDogConfig);
  const site = dataDogConfig.site || "datadoghq.com";

  try {
    window.DD_LOGS.init({
      clientToken,
      site,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: dataDogConfig.service || "service-monitor-app",
      forwardConsoleLogs: dataDogLogLevels,
      forwardReports: "all",
    });
    window.DD_LOGS.setLoggerGlobalContext(getLoggingContext());
    console.log("DataDog logging initialized with levels: %s", dataDogLogLevels.join(", "));
  } catch (error) {
    console.error("Failed to initialize DataDog logging:", error);
  }
}
